import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { useEffect } from 'react'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import * as API from '@/services/api.js'
import { daysBetweenTimestamps, daysSinceTimestamp } from '@/utils/date.js'
import { useResearchContext } from '@/context-state/ResearchContext.jsx'
import { useParams } from 'react-router-dom'
import { removeAdsDuplicationsAndAddDaysRunningAmount } from '@/services/externalAds.jsx'

// 1. get 'my advertisers' and save it to state with 'followed Advertisers'
// 2. get sample of ads with random, and save them to state 
// 3. wehn clicking on an ad's advertiser
//  3a. get it fro state, if not exists fetch it
//  3b. get all of the advertiser's ads and save them to state (both on the externalAds state and on the advertiserToExternalAdsMaps state)



export const ResearchDataProvider = ({ children }) => {

    const { updateManyAdvertiserState, updateFollowedAdvertisersState, updateManyExternalAdsState, updateManyBoardsState, isFetched, setIsFetched } = useResearchContext()
    const { spaceId } = useParams()

    const fetchEssentialResearchData = async () => {
        try {

            const [advertisersTheUserFollowsResponse, externalAdsResponse, boardsResponse] = await Promise.all([
                API.getAdvertisers(),
                API.searchExternalAds(),
                API.getBoardsOfSpace(),
            ])

            const { externalAds } = externalAdsResponse.data

            const unique = removeAdsDuplicationsAndAddDaysRunningAmount(externalAds)

            // Advertisers
            updateManyAdvertiserState(advertisersTheUserFollowsResponse.data)
            updateFollowedAdvertisersState(advertisersTheUserFollowsResponse.data.map(advertiser => advertiser._id))
            // Boards
            updateManyBoardsState(boardsResponse.data, true)
            // External Ads
            updateManyExternalAdsState(unique)

            setIsFetched(true)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }

    useEffect(() => {
        // TODO - this needs to be by space. currently we fetch it each time the user visit this page...
        if (!isFetched) {
            fetchEssentialResearchData()
        }
    }, [spaceId])



    return (
        isFetched ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
    )
}